import React from "react";
import StatusApplication from "./StatusApplication";
import { checkPermission, permissionsConfig } from '../AdminPermission/PermissionChecker';

const UnderReviewApplication = () => {

  const editApplicationPermission = checkPermission(
    permissionsConfig.editUnderReviewApplications.role,
    permissionsConfig.editUnderReviewApplications.action,
    permissionsConfig.editUnderReviewApplications.type
  );
    
  const deleteApplicationPermission = checkPermission(
    permissionsConfig.deleteUnderReviewApplications.role,
    permissionsConfig.deleteUnderReviewApplications.action,
    permissionsConfig.deleteUnderReviewApplications.type
  );
    
  return (
    <StatusApplication appStatus="7" title="Under Review" subTitle="Under Review" application_type="0" pageFrom="under-review-applications" editApplicationPermission={editApplicationPermission} deleteApplicationPermission={deleteApplicationPermission}></StatusApplication>
  )
};

export default UnderReviewApplication;
